import "./index.css";
import { useCallback, useState } from "react";
import { SessionProvider, useSession } from "./lib/session/SessionContext";
import { createSupabaseAuthGateway } from "./lib/session/gateway";
import { resolveAccess } from "./lib/access";
import { parseInvitePath } from "./lib/invitePath";
import { C, font } from "./theme";
import { LoginScreen } from "./screens/LoginScreen";
import { AccessDeniedScreen } from "./screens/AccessDeniedScreen";
import { TenantSelectScreen } from "./screens/TenantSelectScreen";
import { AdminScreen } from "./screens/AdminScreen";
import { InviteFlow } from "./screens/InviteFlow";

const gateway = createSupabaseAuthGateway();

function Root() {
  const { status, userEmail, tenants, tenantsLoaded, activeTenant, logout } = useSession();
  const [inviteCode, setInviteCode] = useState<string | null>(() => parseInvitePath(window.location.pathname));
  const completeInvite = useCallback(() => {
    window.history.replaceState(null, "", "/");
    setInviteCode(null);
  }, []);

  if (status === "loading" || (status === "authed" && !tenantsLoaded)) {
    return <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: font, color: C.light, fontSize: 13 }}>Carregando...</div>;
  }

  if (inviteCode) {
    return <InviteFlow code={inviteCode} onComplete={completeInvite} />;
  }

  if (status === "anon") return <LoginScreen />;

  const allowedTenants = tenants.filter(t => resolveAccess(t.roleSlug) !== "denied");

  if (allowedTenants.length === 0) {
    return <AccessDeniedScreen onLogout={logout} />;
  }

  if (!activeTenant || resolveAccess(activeTenant.roleSlug) === "denied") {
    return <TenantSelectScreen tenants={allowedTenants} onLogout={logout} />;
  }

  return (
    <AdminScreen
      userName={userEmail ?? ""}
      userRole={activeTenant.roleSlug}
      ctName={activeTenant.name}
      tenantId={activeTenant.tenantId}
      onLogout={logout}
    />
  );
}

export function App() {
  return (
    <SessionProvider gateway={gateway}>
      <Root />
    </SessionProvider>
  );
}

export default App;
